import actionTypes from "../action-types";
import { CourseEnrollmentType } from "../models/CourseEnrollment";

export const receiveCourseEnrollments = (
  enrollments: Array<CourseEnrollmentType>
) => ({
  type: actionTypes.RECEIVE_COURSE_ENROLLMENTS,
  payload: {
    enrollments
  }
});

export const saveNewCourseEnrollment = (enrollment: CourseEnrollmentType) => ({
  type: actionTypes.SAVE_NEW_COURSE_ENROLLMENT,
  payload: {
    enrollment
  }
});

export const deleteCourseEnrollment = (courseId: string) => ({
  type: actionTypes.DELETE_COURSE_ENROLLMENT,
  payload: {
    courseId
  }
});
